import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { Progress, Select } from '@backstage/core-components';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useApi } from '@backstage/core-plugin-api';
import { scaffolderApiRef } from '@backstage/plugin-scaffolder-react';
import useAsync from 'react-use/esm/useAsync';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { scaffolderTranslationRef } from '../../../translation.esm.js';

const RepoUrlPickerHost = (props) => {
  const { host, hosts, onChange, rawErrors, isDisabled } = props;
  const { t } = useTranslationRef(scaffolderTranslationRef);
  const scaffolderApi = useApi(scaffolderApiRef);
  const { value: { integrations } = { integrations: [] }, loading } = useAsync(
    async () => {
      return await scaffolderApi.getIntegrationsList({
        allowedHosts: hosts ?? []
      });
    }
  );
  useEffect(() => {
    if (!host) {
      if (hosts?.length) {
        onChange(hosts[0]);
      } else if (integrations?.length) {
        onChange(integrations[0].host);
      }
    }
  }, [hosts, host, onChange, integrations]);
  const hostsOptions = integrations ? integrations.filter((i) => hosts?.length ? hosts?.includes(i.host) : true).map((i) => ({ label: i.title, value: i.host })) : [{ label: "Loading...", value: "loading" }];
  if (loading) {
    return /* @__PURE__ */ jsx(Progress, {});
  }
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    FormControl,
    {
      margin: "normal",
      required: true,
      error: rawErrors?.length > 0 && !host,
      children: [
        /* @__PURE__ */ jsx(
          Select,
          {
            native: true,
            disabled: isDisabled || hosts?.length === 1,
            label: t("fields.repoUrlPicker.host.title"),
            onChange: (s) => onChange(String(Array.isArray(s) ? s[0] : s)),
            selected: host,
            items: hostsOptions,
            "data-testid": "host-select"
          }
        ),
        /* @__PURE__ */ jsx(FormHelperText, { children: t("fields.repoUrlPicker.host.description") })
      ]
    }
  ) });
};

export { RepoUrlPickerHost };
//# sourceMappingURL=RepoUrlPickerHost.esm.js.map
